

























































import { ChatVue } from "fs-pb-vue2/vueModels/app/ChatVue";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: { BackLink },
})
export default class Chat extends ChatVue {
  async mounted() {
    await this.init();
  }

    /**Закрытие формыы */
    async destroyForm(): Promise<void> {
    this.$emit("hideSelf");
  }
}
